import React from 'react';
import { Activity, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const CallReconciliationCard = ({ productionStatus, onReconcile, executing }) => {
  return (
    <Card className="glass-card border-white/20">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Activity className="w-5 h-5 text-primary" />
          <div>
            <CardTitle>Call Reconciliation</CardTitle>
            <CardDescription className="mt-1">Fix phantom "in-progress" calls</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 rounded-lg bg-secondary/50">
            <div className="text-lg font-semibold">{productionStatus?.reconciliation_stats?.total_active || 0}</div>
            <div className="text-xs text-muted-foreground">Total Active</div>
          </div>
          <div className="p-3 rounded-lg bg-secondary/50">
            <div className="text-lg font-semibold text-success">{productionStatus?.reconciliation_stats?.true_active || 0}</div>
            <div className="text-xs text-muted-foreground">True Active</div>
          </div>
        </div>

        <Button
          onClick={onReconcile}
          disabled={executing === 'reconcile'}
          className="w-full gap-2"
          data-testid="reconcile-calls-btn"
        >
          {executing === 'reconcile' ? (
            <><RefreshCw className="w-4 h-4 animate-spin" /> Reconciling...</>
          ) : (
            <><RefreshCw className="w-4 h-4" /> Resync Calls Now</>
          )}
        </Button>

        <p className="text-xs text-muted-foreground">
          Queries Retell for actual call status and closes stale calls (no update {'>'}5 min)
        </p>
      </CardContent>
    </Card>
  );
};

export default CallReconciliationCard;
